export class LanguageVariantElementsBuilder {
    assetElement(element) {
        return element;
    }
    customElement(element) {
        return element;
    }
    dateTimeElement(element) {
        return element;
    }
    linkedItemsElement(element) {
        return element;
    }
    multipleChoiceElement(element) {
        return element;
    }
    numberElement(element) {
        return element;
    }
    richTextElement(element) {
        return element;
    }
    taxonomyElement(element) {
        return element;
    }
    textElement(element) {
        return element;
    }
    urlSlugElement(element) {
        return element;
    }
    any(element) {
        return element;
    }
}
export const languageVariantElementsBuilder = new LanguageVariantElementsBuilder();
//# sourceMappingURL=language-variant-elements-builder.js.map